import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from "vue";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import PersonEditComponent from "@/modules/OrganisationStructure/components/PersonEditComponent.vue";
import AddressEditComponent from "@/modules/OrganisationStructure/components/AddressEditComponent.vue";



interface Props {
  person:Person,
  address:Address,
  visibleAddress?:boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonAddressEditComponent',
  props: {
    person: { default: () => new Person() },
    address: { default: () => {
      const t = new Address();
      t.countryCode = "DE"
      return t;
    } },
    visibleAddress: { type: Boolean, default: true }
  },
  setup(__props: any, { expose: __expose }) {


const props = __props

const _personForm = ref<InstanceType<typeof PersonEditComponent>  | null>(null)
const _addressForm = ref<InstanceType<typeof AddressEditComponent>  | null>(null)

const validate = ( ):boolean => {
  const checkAddress  = _addressForm.value.validate();
  const checkPerson = _personForm.value.validate();
 return checkPerson&& checkAddress;
}

const getAddress = ():Address => {
  return _addressForm.value.getAddress();
}
const getPerson = ():Person => {
  return _personForm.value.getPerson();
}


__expose({
  validate, getAddress, getPerson
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PersonEditComponent, {
      ref_key: "_personForm",
      ref: _personForm,
      person: props.person
    }, null, 8, ["person"]),
    _withDirectives(_createVNode(AddressEditComponent, {
      ref_key: "_addressForm",
      ref: _addressForm,
      address: props.address,
      "show-full-name": false
    }, null, 8, ["address"]), [
      [_vShow, __props.visibleAddress]
    ])
  ]))
}
}

})